import { app } from "modular-openscriptjs";
import OffcanvasComponent from "../OffcanvasComponent";

const h = app("h");

export default class OffcanvasBody extends OffcanvasComponent {
    render(...args) {
        return h.div({ class: "offcanvas-body" }, ...args);
    }
}